// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"bf658138","147":"3375f0a1","285":"9b180c95","372":"6051d721","417":"721dd00f","538":"55ff08ee","787":"349b0e60","852":"c1ca8327","861":"90961edc"}[chunkId] + ".chunk.js";
};